import { getLanguageDetails, Language } from './language';

const getBaseURL = (): string => {
  const baseURL = process.env.NEXT_PUBLIC_URL;

  if (!baseURL) {
    throw new Error('Configuration error: NEXT_PUBLIC_URL environment variable is missing');
  }
  return baseURL;
}

export const generateLocalizedURL = (
  slug: string,
  language: Language,
  usePrefix: boolean = true
): string => {
  if (!slug) {
    throw new Error('Invalid request: Page slug cannot be empty');
  }

  const langConfig = getLanguageDetails(language);

  if (!langConfig || !langConfig.shortCode) {
    throw new Error(`Unsupported language: "${language}" is not configured properly`);
  }

  let urlPath: string;

  if (language === Language.Farsi && !usePrefix) {
    urlPath = `/${slug}`;
  } else {
    urlPath = `/${langConfig.shortCode}/${slug}`;
  }

  const baseURL = getBaseURL();

  return new URL(urlPath, baseURL).toString();
};